<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="employeeNo" label="员工" :rules="[{ required: true, message: '请输入' }]" v-if="!editForm.id">
        <UserSelect v-model:value="editForm.employeeNo" placeholder="请选择员工" allowClear />
      </a-form-item>
      <a-form-item  label="员工" v-if="editForm.id">
        <a-input v-model:value="editForm.userName"  allowClear disabled />
      </a-form-item>
      <a-form-item name="selectedKeys" label="分配区域" :rules="[{ required: true, message: '选择' }]">
        <div class="tree-box">
          <a-tree
            v-model:expandedKeys="expandedKeys"
            v-model:selectedKeys="editForm.selectedKeys"
            v-model:checkedKeys="checkedKeys"
            :checkable="false"
            :tree-data="treeData"
            :fieldNames="{ children: 'children', title: 'name', key: 'id' }"
            @select="handleSelect"
          >
            <template #title="{ name }">
              <span>{{ name }}</span>
            </template>
          </a-tree>
        </div>
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, onMounted } from 'vue'
import { userCustomerAreaSave, getCustomerArea } from '@/api/common'
import type { FormInstance, TreeProps } from 'ant-design-vue'
import { UserCustomerAreaSaveParams } from '@/typings/common'
import { DcMessage } from '@dc-platform/dc-components'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<any>({ employeeNo: '' })
const emit = defineEmits(['success'])
const expandedKeys = ref<any>([])
const selectedKeys = ref<any>([])
const checkedKeys = ref<any>([])
const treeData = ref<TreeProps['treeData']>()
const path = ref<string>()
const toggle = (row?: UserCustomerAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
    const arr = [row.areaId.toString()]
    expandedKeys.value = arr
    editForm.value.selectedKeys = arr
    selectedKeys.value = arr
    path.value = row.path
  } else {
    editForm.value = {}
    expandedKeys.value = []
    editForm.value.selectedKeys = []
    selectedKeys.value = []
    path.value = ''
  }
}
const handleSelect = (selectedKeys: any, { node }: any) => {
  console.log('val: ', selectedKeys)
  path.value = node.path
}

const getTree = async () => {
  try {
    const res = await getCustomerArea({ appId: 'cos_lbu' })
    treeData.value = res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    try {
      if (editForm.value.selectedKeys.length > 0) {
        await userCustomerAreaSave({
          employeeNo: editForm.value.employeeNo,
          areaId: editForm.value.selectedKeys[0],
          appId: 'cos_lbu'
          // path: path.value
        })
        loading.value = false

        emit('success', editForm.value?.id ? 'edit' : 'add')
        DcMessage.success(editForm.value?.id ? '分配成功' : '新增成功')
        toggle()
      } else {
        loading.value = false

        DcMessage.error('请先选择需要分配的区域！')
      }
    } catch (error) {
      loading.value = false
    }
  })
}
onMounted(() => {
  getTree()
})
defineExpose({
  toggle
})
</script>

<style lang="scss">
.tree-box {
  // border: 1px solid #d8dfe4;
  border-radius: 4px;
  padding: 5px;
}
</style>
